import React, { useContext } from 'react'
import { AppContext } from '../context/AppContext';
import MensionUsers from './MensionUsers';

// Renders the quoted-message slot above a reply bubble. It must show ONLY the
// original message being replied to — the parent (MessageList) already renders
// the new reply text inside its own bubble, so duplicating `msg` here produced
// the "same text above and below" effect, especially visible on nested replies.
export default function RepliesTo({ sernderName, msg, repliedTo, msgRef, mensioned, index }) {
    const { conversations, newMessages } = useContext(AppContext)

    // Prefer the quoted message's sender; fall back to the caller-provided
    // `sernderName` (which is the new-message sender) only when the quoted
    // sender isn't available, so the label still has something to show.
    const quotedSender =
        (repliedTo &&
            (repliedTo.sender_name ||
                [repliedTo.FirstName, repliedTo.LastName].filter(Boolean).join(" "))) ||
        sernderName ||
        ""

    const quotedText =
        (repliedTo && (repliedTo.Team_Message_Text || repliedTo.message)) || ""

    const scrollToOriginal = () => {
        if (!repliedTo) return
        const msgIndex = conversations.indexOf(repliedTo)
        const reference = msgIndex !== -1
            ? msgRef && msgRef.current && msgRef.current[msgIndex]
            : msgRef && msgRef.current && msgRef.current[conversations.length + newMessages.indexOf(repliedTo)]
        reference && reference.scrollIntoView && reference.scrollIntoView()
    }

    return (
        <div className={"repliesTo "} style={{ maxWidth: '70%' }}>
            <div className='receive-msg' >
                <div className="right-receive-msg" onClick={scrollToOriginal} >
                    <span className="senderName">{quotedSender}</span>
                    {quotedText ?
                        <div className="receive-msg-main">
                            <p className="msg-text" style={{ textAlign: 'start' }}>{
                                quotedText.includes("@") ?
                                    <MensionUsers text={quotedText} users={mensioned} index={index} />
                                    :
                                    quotedText}</p>
                        </div>
                        : null
                    }
                </div>
            </div>
        </div>
    )
}
